import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
export var useAuth = function () {
    return useContext(AuthContext);
};
